//
//
//
//
//

    export default{
        data(){
            return{

            }
        },
        props:['title']
    }



// WEBPACK FOOTER //
// ./src/components/sub_button.vue